/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Ne pas vendre ou partager mes données personnelles",
      "Bumble Date",
      "Nos applications",
      "À propos",
      "Emploi",
      "Nous contacter",
      "Investir",
      "Boutique",
      "Entreprise",
      "Télécharger l'appli",
      "Accessibilité chez Bumble",
      "Charte",
      "Gérer les cookies",
      "Loi du Royaume-Uni sur l’esclavage moderne",
      "Gestion des données",
      "Politique de confidentialité",
      "Conditions générales",
      "Informations légales",
      "Politique de confidentialité des données de santé dans l'État de Washington",
      "Scanne le code QR pour télécharger l'appli Bumble",
      "Résilier les contrats",
      "Fermer le menu",
      "Ouvrir le menu",
      "Choix de la langue",
      "Pied de page",
      "Accessibilité chez Bumble",
      "Apple et le logo Apple sont des marques déposées d'Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Emploi",
      "Google Play est une marque de Google LLC.",
      "Charte",
      "Investisseurs",
      "Gérer les cookies",
      "Loi sur l'esclavage moderne",
      "Avis de collecte",
      "Confidentialité",
      "Guides de rencontres saisonniers",
      "Conditions",
      "L'appli",
      "Politique de confidentialité des données de santé du consommateur de Washington",
      "À propos",
      "Ambassadeurs",
      "Fais-toi de nouveaux amis qui te correspondent",
      "Développe ton réseau professionnel et booste ta carrière",
      "Trouve une relation sérieuse, une aventure sans lendemain ou autre chose",
      "Blog",
      "En savoir plus",
      "Parcours le monde avec le mode Voyage",
      "Date",
      "Fonctionnalités",
      "Compliments",
      "Envoie des Compliments pour te démarquer.",
      "À découvrir",
      "Une page personnalisée qui met en avant les profils les plus compatibles avec toi, actualisée chaque jour.",
      "Mode Incognito",
      "Utilise le mode Incognito pour éviter que ton patron, tes proches ou tes ex ne voient ton profil.",
      "Match instantané",
      "Tu as commencé la discussion à un événement Bumble IRL ? Poursuis‑la sur l'application.",
      "Opening Moves",
      "Choisis des Opening Moves qui invitent ton match à lancer la discussion, pour que tu n’aies pas à le faire.",
      "Mode Snooze",
      "Prends un moment pour toi avec le mode Snooze. Quand tu voudras revenir, nous serons là.",
      "SuperSwipe",
      "Son profil t'intéresse ? Montre-le en lui envoyant un SuperSwipe.",
      "Mode Voyage",
      "Trouve ton bonheur n’importe où dans le monde grâce au mode Voyage.",
      "Appel vidéo",
      "Passe des appels vidéo et audio pour vérifier si c'est le bon moment pour une rencontre en personne.",
      "Application web",
      "Découvre l’expérience Bumble directement depuis ton navigateur.",
      "Télécharge l'application Bumble",
      "BFF",
      "Sécurité",
      "Histoires",
      "Aide",
      "Boutique",
      "Principale",
      "Envoie des Compliments pour te démarquer.",
      "Compliments",
      "Des fonctionnalités conçues pour t'aider à tisser de véritables relations authentiques.",
      "Masque ton profil pour ton patron, tes proches ou tes ex.",
      "Mode Incognito",
      "Prends un moment pour toi avec le mode Snooze.",
      "Mode Snooze",
      "Quelqu’un t’a tapé dans l’œil ? Dis-le-lui !",
      "SuperSwipe",
      "Découvrir le mode Date",
      "Fais des rencontres partout dans le monde.",
      "Mode Voyage",
      "Rapproche-toi de tes matchs sans sortir de chez toi.",
      "Appels vidéo",
      "Les figures de notre communauté font voyager les valeurs de Bumble dans tout le pays.",
      "Figures de la communauté",
      "Des fonctionnalités conçues pour t’aider à trouver des personnes qui te ressemblent et créer du lien grâce à vos points communs.",
      "Organise une rencontre de groupe ou découvre les événements qui ont lieu autour de toi.",
      "Plans",
      "Découvre BFF",
      "Tous les conseils et l’inspiration dont tu as besoin pour vivre des histoires d’amour et d’amitié.",
      "Conseils et histoires pour t’aider à nouer les amitiés idéales.",
      "Le carrefour de l'amitié",
      "De Tokyo à Toronto, rencontre l’amour sur Bumble partout dans le monde.",
      "Histoires d’amour",
      "Prévois le date parfait, n’importe où et n’importe quand, avec qui que tu sois.",
      "Guides de rencontres saisonniers",
      "Découvrir les histoires",
      "Lire la suite",
      "Bumble sur {{social_network}}",
      "Contact",
      "Se connecter",
      "(ouvre une nouvelle fenêtre)",
      "FAQ",
      "Politique des cookies",
      "Bumble - Le Blog",
      "Emploi",
      "Chat",
      "Villes",
      "Gérer les cookies",
      "Dépôt légal © 2006 - aujourd'hui. Bumble. Tous droits réservés.",
      "Rapport sur la confiance dans les rencontres",
      "Apple et le logo Apple sont des marques déposées d'Apple Inc.{{__EOL__}}Google Play est une marque déposée de Google LLC.",
      "Télécharger",
      "Facebook",
      "Pour nous suivre :",
      "Centre d'aide",
      "Instagram",
      "Langue",
      "LinkedIn",
      "Bumble fait partie de Bumble Inc.",
      "Politique de Confidentialité",
      "Safety Centre",
      "Plan du site",
      "Loi sur l'esclavage moderne",
      "Conditions Générales d'Utilisation",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "jours"
            ],
            "singular": [
                  "jour"
            ]
      },
      "hour": {
            "plural": [
                  "heures"
            ],
            "singular": [
                  "heure"
            ]
      },
      "minute": {
            "plural": [
                  "minutes"
            ],
            "singular": [
                  "minute"
            ]
      },
      "month": {
            "plural": [
                  "mois"
            ],
            "singular": [
                  "mois"
            ]
      },
      "second": {
            "plural": [
                  "secondes"
            ],
            "singular": [
                  "seconde"
            ]
      },
      "year": {
            "plural": [
                  "ans"
            ],
            "singular": [
                  "an"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
